module.exports = __webpack_public_path__ + "static/media/nexatlas_icon.dda691a4.png";